module.exports = __webpack_public_path__ + "img/ring_r_s_1_null@2x.5d075ef5.png";